import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";

import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { PricingRequestsPage } from "@/components/features/Procurement/design/PricingRequestsPanel";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

const pricingSearchSchema = z.object({
  focus: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authenticated/procurement/pricing/")({
  component: ProcurementPricingRoute,
  validateSearch: pricingSearchSchema.parse,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function ProcurementPricingRoute() {
  const { focus } = useSearch({ from: "/_authenticated/procurement/pricing/" });

  useBreadcrumb([
    {
      title: "Procurement",
      href: "/procurement",
      icon: getRouteIcon(MODULE_KEYS_MAP.procurement),
    },
    { title: "Pricing Requests", href: "/procurement/pricing" },
  ]);

  return <PricingRequestsPage focusId={focus} />;
}
